import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { Point } from "../../components/eMapping/3dView/types";
import { getFacilityDeviceLocations } from "../thunk/locationThunk";

interface InitialState {
  locationList: any;
  loading: boolean;
  currentFacilityDeviceLocations: Point[];
}

const initialState: InitialState = {
  locationList: [],
  loading: false,
  currentFacilityDeviceLocations: []
};

const locationSlice = createSlice({
  name: "location",
  initialState,
  reducers: {
    locationList: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      locationList: action.payload,
    }),
    setLoader: (state: Draft<InitialState>, action: PayloadAction<any>) => ({
      ...state,
      loading: action.payload,
    }),
    addDeviceLocation(state, action: PayloadAction<Point>) {
      const isExists = state?.currentFacilityDeviceLocations?.find(value => value?.id === action?.payload?.id);
      if (isExists) {
        const deviceLocations = state?.currentFacilityDeviceLocations.map(value => value.id === action?.payload?.id ? {
          ...value,
          position: action?.payload?.position
        } : value);
        return {
          ...state,
          currentFacilityDeviceLocations: deviceLocations
        };
      } else {
        return {
          ...state,
          currentFacilityDeviceLocations: [...state?.currentFacilityDeviceLocations, action.payload]
        };
      }
    },
    updateDeviceLocation(state, action: PayloadAction<{ id: string, updates: Partial<Point> }>) {
      state.currentFacilityDeviceLocations = state.currentFacilityDeviceLocations.map((pt) =>
        pt.id === action.payload.id ? { ...pt, ...action.payload.updates } : pt
      );
    },
    removeDeviceLocation(state, action: PayloadAction<string>) {
      state.currentFacilityDeviceLocations = state.currentFacilityDeviceLocations.filter((pt) => pt.id !== action.payload);
    }
  },
  extraReducers(builder) {
    builder.addCase(getFacilityDeviceLocations.fulfilled, (state, action) => {
      state.currentFacilityDeviceLocations = action.payload;
    });
  },
});

export const { locationList, setLoader, addDeviceLocation, updateDeviceLocation, removeDeviceLocation } = locationSlice.actions;

export default locationSlice.reducer;
